import axios from 'axios'

import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/auth'

export default {

  async login (credentials) {
    const headers = await getHeaders()
    return axios.post(prefix + '/login', credentials, { headers })
  },

  async logout () {
    const headers = await getHeaders()
    return axios.get(prefix + '/logout', { headers })
  },

  async reinitSelfPwd (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/password/reset', criterias, { headers })
  }
}
